// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"tY-z","sponsoredTooltipWrapper":"uY-z","sponsoredTooltip":"vY-z","newCard":"wY-z"};